// extracted by mini-css-extract-plugin
module.exports = {"delete-button":"styles-module__delete-button____dgRg"};